import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FiDollarSign, FiBriefcase, FiType, FiCreditCard, FiFileText, FiCheckCircle } from 'react-icons/fi';

const TransactionEntry = () => {
  const [formData, setFormData] = useState({
    party: '',
    type: 'credit',
    amount: '',
    description: '',
    paymentMethod: 'cash',
    chequeNumber: '',
  });
  const [parties, setParties] = useState([]);

  useEffect(() => {
    axios.get('https://api.pranucollection.com/api/parties')
      .then(res => setParties(res.data))
      .catch(err => console.error('Error loading parties:', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://api.pranucollection.com/api/ledger/add', formData);
      alert('Transaction recorded!');
      setFormData({
        party: '',
        type: 'credit',
        amount: '',
        description: '',
        paymentMethod: 'cash',
        chequeNumber: ''
      });
    } catch (err) {
      alert('Error saving transaction');
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded-2xl shadow-lg">
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
          <FiCheckCircle className="text-green-600" />
          New Transaction
        </h2>
        <p className="text-gray-500 mt-2">Record financial transactions with partners</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Business Selection */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <FiBriefcase className="text-blue-500" />
              Select Business
            </label>
            <select
              name="party"
              value={formData.party}
              onChange={(e) => setFormData({ ...formData, party: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-300 focus:border-blue-500 transition-all"
              required
            >
              <option value="">Choose a business...</option>
              {parties.map(p => (
                <option key={p._id} value={p._id}>{p.name} ({p.type})</option>
              ))}
            </select>
          </div>

          {/* Transaction Type */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <FiType className="text-purple-500" />
              Transaction Type
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-300 focus:border-purple-500 transition-all"
            >
              <option value="credit" className="text-green-600">Money to Take (Credit)</option>
              <option value="debit" className="text-red-600">Money to Give (Debit)</option>
            </select>
          </div>

          {/* Amount */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <FiDollarSign className="text-green-500" />
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-300 focus:border-green-500 transition-all"
              required
              step="0.01"
              placeholder="₹0.00"
            />
          </div>

          {/* Payment Method */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <FiCreditCard className="text-orange-500" />
              Payment Method
            </label>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-orange-300 focus:border-orange-500 transition-all"
            >
              <option value="cash">Cash</option>
              <option value="cheque">Cheque</option>
              <option value="bank">Bank Transfer</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Cheque Details */}
          {formData.paymentMethod === 'cheque' && (
            <div className="md:col-span-2 space-y-1 animate-slideDown">
              <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                <FiFileText className="text-blue-400" />
                Cheque Details
              </label>
              <input
                name="chequeNumber"
                value={formData.chequeNumber}
                onChange={(e) => setFormData({ ...formData, chequeNumber: e.target.value })}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-300 focus:border-blue-500 transition-all"
                placeholder="Enter cheque number and bank details"
              />
            </div>
          )}

          {/* Description */}
          <div className="md:col-span-2 space-y-1">
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <FiFileText className="text-gray-500" />
              Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-gray-300 focus:border-gray-500 transition-all"
              placeholder="Add transaction notes, purpose, or reference..."
              rows="3"
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-4 px-6 rounded-xl transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2"
        >
          <FiCheckCircle className="text-xl" />
          Record Transaction
        </button>
      </form>
    </div>
  );
};

export default TransactionEntry;